import * as React from 'react';
import { Button } from 'react-bootstrap';
import { IItem } from './types';

interface IProps {
    data: IItem,
    onReviewRequest: (requestId: number) => void,
}

const Row = (props: IProps) => {
    return (
        <tr>
            <td>{props.data.name}</td>
            <td>{props.data.alias}</td>
            <td>{(props.data.weeks != null ? props.data.weeks : []).join(', ')}</td>
            <td style={{ minWidth: '10em' }}>
                <Button
                    bsStyle="primary"
                    bsSize="sm"
                    onClick={() => props.onReviewRequest(props.data.requestId)}
                >
                    Review Request
                </Button>
            </td>
        </tr>
    );
}

export default Row;
